export const ListMessageIcon = ({ className }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="40"
      height="40"
      viewBox="0 0 45 45"
      fill="none"
    >
      {/*<circle opacity="0.1" cx="20" cy="20" r="20" fill="#884EA2" /> */}
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M10 15.0327C10 13.3577 11.3992 12 13.1251 12H26.8749C28.6008 12 30 13.3577 30 15.0327V23.5244C30 25.1992 28.6008 26.5571 26.8749 26.5571H17.3975L14.2169 29.811C14.041 29.9908 13.7699 30.0487 13.5325 29.957C13.295 29.8654 13.139 29.6428 13.1384 29.3948L13.1327 26.5571H13.1251C11.3992 26.5571 10 25.1992 10 23.5244L10 15.0327ZM16.2502 18.0654C15.5599 18.0654 15.0002 18.6084 15.0002 19.2785C15.0002 19.9485 15.5599 20.4915 16.2502 20.4915C16.9406 20.4915 17.5001 19.9485 17.5001 19.2785C17.5001 18.6084 16.9406 18.0654 16.2502 18.0654ZM18.7502 19.2785C18.7502 18.6084 19.3097 18.0654 20.0002 18.0654C20.6906 18.0654 21.2501 18.6084 21.2501 19.2785C21.2501 19.9485 20.6906 20.4915 20.0002 20.4915C19.3097 20.4915 18.7502 19.9485 18.7502 19.2785ZM23.7501 18.0654C23.0597 18.0654 22.5001 18.6084 22.5001 19.2785C22.5001 19.9485 23.0597 20.4915 23.7501 20.4915C24.4405 20.4915 25 19.9485 25 19.2785C25 18.6084 24.4405 18.0654 23.7501 18.0654Z"
        className={className}
      />
    </svg>
  );
};
